import { Action } from 'redux';
import { PlanDetailsStateStructure } from '../interfaces/planDetailsStateStructure.interface';
import { PlanTypesCollection } from '../../interfaces/plan-types-collection.interface';

export const PLAN_DETAILS_STATE_NAME = 'PlanDetails';
/** INITIAL STATE */
const INITIAL_STATE: PlanDetailsStateStructure = {
  comparablePlanIds: [],
  individualPlanIdForPlanDetails: null,
  lastQueriedPlanIds: [],
  planDetails: null
};

/** ACTION TYPES */
const SAVE_COMPARABLE_PLAN_IDS = 'SAVE_COMPARABLE_PLAN_IDS';
const SAVE_INDIVIDUAL_PLAN_ID = 'SAVE_INDIVIDUAL_PLAN_ID';
const RESET_COMPARE_PLANS_CHECKED = 'RESET_COMPARE_PLANS_CHECKED';
const SAVE_PLAN_DETAILS = 'SAVE_PLAN_DETAILS';
const UPDATE_LAST_QUERIED_IDS = 'UPDATE_LAST_QUERIED_IDS';
const HOTSWAP_STATE = `${PLAN_DETAILS_STATE_NAME}_HOTSWAP_STATE`;
const CLEAR_PLAN_DETAILS = 'CLEAR_PLAN_DETAILS';

/** ACTION INTERFACE - which implements Redux's ACTION */
export class PlanDetailsAction implements Action {
  type: string;
  comparablePlanIds?: string[];
  lastQueriedPlanIds?: string[];
  individualPlanIdForPlanDetails?: string;
  planDetails?: PlanTypesCollection;
  newState?: PlanDetailsStateStructure;
}

/** ACTIONS */
export function comparePlansByIds(
  comparablePlanIds: string[]
): PlanDetailsAction {
  return { type: SAVE_COMPARABLE_PLAN_IDS, comparablePlanIds };
}

export function planDetailsByPlanId(individualPlanIdForPlanDetails: string): PlanDetailsAction {
  return { type: SAVE_INDIVIDUAL_PLAN_ID, individualPlanIdForPlanDetails };
}

export function resetComparePlansChecked(): PlanDetailsAction {
  return { type: RESET_COMPARE_PLANS_CHECKED };
}

export function savePlanDetails(planDetails: PlanTypesCollection): PlanDetailsAction {
  return { type: SAVE_PLAN_DETAILS, planDetails };
}

export function updateLastQueriedIds(lastQueriedPlanIds: string[]): PlanDetailsAction {
  return { type: UPDATE_LAST_QUERIED_IDS, lastQueriedPlanIds };
}

export function hotswapPlanDetailsState(newState: PlanDetailsStateStructure): PlanDetailsAction {
  return { type: HOTSWAP_STATE, newState };
}

export function clearPlanDetails(): PlanDetailsAction {
  return { type: CLEAR_PLAN_DETAILS };
}

export function PlanDetails(
  state: PlanDetailsStateStructure = INITIAL_STATE,
  action: PlanDetailsAction
) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {
    case SAVE_COMPARABLE_PLAN_IDS:
      /** Save Comparable Plan Ids */
      copiedState.comparablePlanIds = action.comparablePlanIds;
      /** Reset Plan Id for PlanDetails */
      copiedState.individualPlanIdForPlanDetails = INITIAL_STATE.individualPlanIdForPlanDetails;
      return Object.assign({}, state, copiedState);
    case SAVE_INDIVIDUAL_PLAN_ID:
      /** Save Plan Id for PlanDetails */
      copiedState.individualPlanIdForPlanDetails = action.individualPlanIdForPlanDetails;
      /** Reset Comparable Plan Ids */
      copiedState.comparablePlanIds = INITIAL_STATE.comparablePlanIds;
      return Object.assign({}, state, copiedState);
    case RESET_COMPARE_PLANS_CHECKED:
      copiedState.comparablePlanIds = [];
      return Object.assign({}, state, copiedState);
    case SAVE_PLAN_DETAILS:
      copiedState.planDetails = action.planDetails;
      return Object.assign({}, state, copiedState);
    case UPDATE_LAST_QUERIED_IDS:
      copiedState.lastQueriedPlanIds = action.lastQueriedPlanIds;
      return Object.assign({}, state, copiedState);
    case HOTSWAP_STATE:
      // Replace the entire state with the new state
      return action.newState;
    case CLEAR_PLAN_DETAILS:
      return Object.assign({}, state, INITIAL_STATE);
    default:
      return state;
  }
}
